import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCandidateProfile, addCandidateResume, fetchBasicDetailsBySingleParam, updateCandidateDetails } from "./BasicDetailsSingleParamAPI";


const initialState = {
    value: 0,
    status: "idle",
    basicDetail: {},
    profile: [],
    resume: [],
};

export const fetchBasicDetailsBySingleParamAsync = createAsyncThunk(
    "candidate/fetchBySingleParam",
    async () => {
        const response = await fetchBasicDetailsBySingleParam();
        return response;
    }
);

export const updateCandidateDetailsAsync = createAsyncThunk(
    "candidate/update",
    async ({ uuid, candidateData }) => {
        try {
            const response = await updateCandidateDetails(uuid, candidateData);
            // console.log("Saved data", candidateData);
            return response;
        } catch (error) {
            // return rejectWithValue(error.message);
        }
    }
);

export const addCandidateProfileAsync = createAsyncThunk(
    "CandidateProfile/upload",
    async ({ formData }, { rejectWithValue }) => {
        try {
            const result = await addCandidateProfile(formData);
            // console.log("result in slice", result)
            return result;
        } catch (error) {
            return rejectWithValue(error.message); // If error occurs, return the error message
        }
    }
);
export const addCandidateResumeAsync = createAsyncThunk(
    "CandidateResume/upload",
    async ({ formData }, { rejectWithValue }) => {
        try {
            const result = await addCandidateResume(formData);

            return result;
        } catch (error) {
            return rejectWithValue(error.message); // If error occurs, return the error message
        }
    }
);

const candDashBasicDetailsBySingleParam = createSlice({
    name: "candidateProfile/basicDetailsBySingleParam",
    initialState,
    extraReducers: (builder) => {
        builder

            .addCase(fetchBasicDetailsBySingleParamAsync.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchBasicDetailsBySingleParamAsync.fulfilled, (state, action) => {
                state.status = "idle";
                state.basicDetail = action.payload;
            })
            .addCase(fetchBasicDetailsBySingleParamAsync.rejected, (state) => {
                state.status = "idle";
            })

            .addCase(addCandidateProfileAsync.fulfilled, (state, action) => {
                state.profile.push(action.payload);
                console.log("state.data", state.data)
            })
            .addCase(addCandidateProfileAsync.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(addCandidateResumeAsync.fulfilled, (state, action) => {
                state.resume.push(action.payload);
            })
            .addCase(addCandidateResumeAsync.rejected, (state, action) => {
                state.error = action.payload;
            })

            .addCase(updateCandidateDetailsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCandidateDetailsAsync.fulfilled, (state, action) => {
                state.loading = false;

                if (Array.isArray(state.data)) {
                    const updatedDetailsIndex = state.data.findIndex(
                        (candidateData) => candidateData.uuid === action.payload.uuid
                    );

                    if (updatedDetailsIndex !== -1) {
                        state.data[updatedDetailsIndex] = action.payload;
                    }
                } else {
                    state.data = [action.payload];
                }
            })

            .addCase(updateCandidateDetailsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message || "Failed to update project";
            });

    },
});

export const selectBasicDetailsBySingleParam = (state) =>
    state.candProfileBasicDetailsBySingleParam.basicDetail;

export default candDashBasicDetailsBySingleParam.reducer;




